import { EditorState } from "@codemirror/state";
import { EditorView } from "@codemirror/view";
import React, { useEffect, useRef } from "react";
import {
  cmExtensions,
  cmLanguageExtensions,
} from "../sandbox/ExpressionEditor";

export function GeneratedCode({ expression }: { expression: string }) {
  const editorRef = useRef<HTMLDivElement | null>(null);
  const cmViewRef = useRef<EditorView | undefined>(undefined);
  useEffect(() => {
    const cmView = new EditorView({
      state: EditorState.create({
        doc: expression,
        extensions: [
          ...cmExtensions,
          ...cmLanguageExtensions,
          EditorView.editable.of(false),
        ],
      }),
      parent: editorRef.current!,
    });
    cmViewRef.current = cmView;
    return () => {
      cmView.destroy();
    };
  }, []);
  useEffect(() => {
    const cmView = cmViewRef.current;
    if (cmView !== undefined) {
      cmView.dispatch({
        changes: {
          from: 0,
          to: cmView.state.doc.length,
          insert: expression,
        },
      });
    }
  }, [expression]);
  return <div className="select-text" ref={editorRef} />;
}
